import Dom from './modules/constructors.js'; //selecionar elementos
import menu from './modules/menu.js';

// PAGES
import scriptsBlog from './modules/scriptsPaginas/blog.js';
import scriptsContato from './modules/scriptsPaginas/contato.js';
import scriptsHome from './modules/scriptsPaginas/home.js';
import scriptsPlanos from './modules/scriptsPaginas/planos.js';
import scriptsQuemSomos from './modules/scriptsPaginas/quemsomos.js';
import scriptsSingleBlog from './modules/scriptsPaginas/single-blog.js';
import scriptsSolucoes from './modules/scriptsPaginas/solucoes.js';

// UTILS
import { animaAoScroll } from './modules/animation.js';
import modalContato from './modules/modalContato.js?v=2';
// import faq from './modules/faq.js'; // @deprecated
// import mosaic from './modules/mosaic.js'; // @deprecated

// let mediaQuery = window.matchMedia('(min-width: 1024px)').matches
document.addEventListener('DOMContentLoaded', () => {

// SCRIPTS GERAIS
menu();
animaAoScroll();
modalContato();

// PAGES
const pageHome = new Dom().el('#page__home');
const pageSolucoes = new Dom().el('#page__solucoes');
const pagePlanos = new Dom().el('#page__planos');
const pageQuemSomos = new Dom().el('#page__quem-somos');
const pageBlog = new Dom().el('#page__blog');
const pageSingleBlog = new Dom().el('#page__single-blog');
const pageContato = new Dom().el('#page__contato');

if (pageHome) {
  // ★ HOME
  // new Dom().bodyClass('body__home'); // via wp hook
  scriptsHome();
  //faq();

} else if (pageSolucoes) {
  // ★ Clientes
  // new Dom().bodyClass('body__solucoes'); // via wp hook
  scriptsSolucoes();
  // faq();
} else if (pagePlanos) {
  // ★ Clientes
  // new Dom().bodyClass('body__planos'); // via wp hook
  scriptsPlanos();
} else if (pageQuemSomos) {
  // ★ Clientes
  // new Dom().bodyClass('body__quem-somos'); // via wp hook
  scriptsQuemSomos();
  // mosaic(16, [
  //   '#FFAD00',
  //   '#019DD6',
  //   '#FF6400',
  //   '#FFB200',
  //   '#001F8C',
  //   '#FDEC71',
  //   '#FFE500',
  // ]);
} else if (pageBlog) {
  // ★ Clientes
  // new Dom().bodyClass('body__blog');
  scriptsBlog();
} else if (pageSingleBlog) {
  // ★ Clientes
  // new Dom().bodyClass('body__single-blog');
  scriptsSingleBlog();
} else if (pageContato) {
  // ★ Clientes
  // new Dom().bodyClass('body__contato'); // via wp hook
  scriptsContato();
}
});



// document.addEventListener('DOMContentLoaded', () => {
//   document.body.classList.add('dcl');
// });
